import mainLogo from '@/assets/images/mainLogo.png';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/shared/provider/AuthProvider';
import { useNavigate } from 'react-router-dom';

const Header = () => {
	// Hooks
	const { userInfo, onLogout } = useAuth();

	const navigate = useNavigate();

	return (
		<div className="flex items-center justify-between px-4 py-3 ">
			<img src={mainLogo} alt="" />
			{userInfo ? (
				<Button
					variant="outline"
					size="sm"
					className="px-[8.5px]"
					onClick={onLogout}>
					Log out
				</Button>
			) : (
				<Button
					variant="outline"
					size="sm"
					className="px-[8.5px]"
					onClick={() => navigate('/login')}>
					Log in
				</Button>
			)}
		</div>
	);
};

export default Header;
